"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DownOutlined = _interopRequireDefault(require("@ant-design/icons/DownOutlined"));
var _LeftOutlined = _interopRequireDefault(require("@ant-design/icons/LeftOutlined"));
var _RightOutlined = _interopRequireDefault(require("@ant-design/icons/RightOutlined"));
var _UpOutlined = _interopRequireDefault(require("@ant-design/icons/UpOutlined"));
var _classnames = _interopRequireDefault(require("classnames"));
function getValidNumber(num) {
  return typeof num === 'number' && !Number.isNaN(num) ? Math.round(num) : 0;
}
var SplitBar = function SplitBar(props) {
  var prefixCls = props.prefixCls,
    vertical = props.vertical,
    index = props.index,
    active = props.active,
    ariaNow = props.ariaNow,
    ariaMin = props.ariaMin,
    ariaMax = props.ariaMax,
    resizable = props.resizable,
    startCollapsible = props.startCollapsible,
    endCollapsible = props.endCollapsible,
    onOffsetStart = props.onOffsetStart,
    onOffsetUpdate = props.onOffsetUpdate,
    onOffsetEnd = props.onOffsetEnd,
    onCollapse = props.onCollapse;
  var splitBarPrefixCls = "".concat(prefixCls, "-bar");
  // ======================== Resize ========================
  var _ref = (0, _react.useState)(null),
    _ref2 = _slicedToArray(_ref, 2),
    startPos = _ref2[0],
    setStartPos = _ref2[1];
  var onMouseDown = function onMouseDown(e) {
    if (resizable && e.currentTarget) {
      setStartPos([e.pageX, e.pageY]);
      onOffsetStart(index);
    }
  };
  var onTouchStart = function onTouchStart(e) {
    if (resizable && e.touches.length === 1) {
      var touch = e.touches[0];
      setStartPos([touch.pageX, touch.pageY]);
      onOffsetStart(index);
    }
  };
  _react["default"].useEffect(function () {
    if (startPos) {
      var onMouseMove = function onMouseMove(e) {
        var pageX = e.pageX,
          pageY = e.pageY;
        var offsetX = pageX - startPos[0];
        var offsetY = pageY - startPos[1];
        onOffsetUpdate(index, offsetX, offsetY);
      };
      var onMouseUp = function onMouseUp() {
        setStartPos(null);
        onOffsetEnd();
      };
      var handleTouchMove = function handleTouchMove(e) {
        if (e.touches.length === 1) {
          var touch = e.touches[0];
          var offsetX = touch.pageX - startPos[0];
          var offsetY = touch.pageY - startPos[1];
          onOffsetUpdate(index, offsetX, offsetY);
        }
      };
      var handleTouchEnd = function handleTouchEnd() {
        setStartPos(null);
        onOffsetEnd();
      };
      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
      return function () {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('touchmove', handleTouchMove);
        window.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [startPos]);
  // ======================== Render ========================
  var StartIcon = vertical ? _UpOutlined["default"] : _LeftOutlined["default"];
  var EndIcon = vertical ? _DownOutlined["default"] : _RightOutlined["default"];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: splitBarPrefixCls,
    role: "separator",
    "aria-valuenow": getValidNumber(ariaNow),
    "aria-valuemin": getValidNumber(ariaMin),
    "aria-valuemax": getValidNumber(ariaMax)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("".concat(splitBarPrefixCls, "-dragger"), _defineProperty(_defineProperty({}, "".concat(splitBarPrefixCls, "-dragger-disabled"), !resizable), "".concat(splitBarPrefixCls, "-dragger-active"), active)),
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart
  }), startCollapsible && (/*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("".concat(splitBarPrefixCls, "-collapse-bar"), "".concat(splitBarPrefixCls, "-collapse-bar-start")),
    onClick: function onClick() {
      return onCollapse(index, 'start');
    }
  }, /*#__PURE__*/_react["default"].createElement(StartIcon, {
    className: (0, _classnames["default"])("".concat(splitBarPrefixCls, "-collapse-icon"), "".concat(splitBarPrefixCls, "-collapse-start"))
  }))), endCollapsible && (/*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("".concat(splitBarPrefixCls, "-collapse-bar"), "".concat(splitBarPrefixCls, "-collapse-bar-end")),
    onClick: function onClick() {
      return onCollapse(index, 'end');
    }
  }, /*#__PURE__*/_react["default"].createElement(EndIcon, {
    className: (0, _classnames["default"])("".concat(splitBarPrefixCls, "-collapse-icon"), "".concat(splitBarPrefixCls, "-collapse-end"))
  }))));
};
var _default = exports["default"] = SplitBar;